/**
 * A print failure on the device-local printer whose message is already
 * user-facing and localized (Bluetooth off, printer not found, out of
 * paper, ...). `printReceipt` shows it verbatim instead of the generic
 * print-error copy.
 */
export class DevicePrinterUserError extends Error {
  constructor(message: string, options?: ErrorOptions) {
    super(message, options);
    this.name = "DevicePrinterUserError";
  }
}
